import { Transaction } from "appworks/services/transaction/transaction";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { gamevy } from "gamevy/gamevy";

export class GamevyTransaction extends Transaction {

    public setBalance(value: number) {
        gamevy.commonUI.updateBalance({ amount: value }, {
            promoInfo: gamevy.balancePromoInfo,
            realAmount: gamevy.balanceData?.REAL,
            bonusAmount: gamevy.balanceData?.BONUS
        });

        super.setBalance(value);
    }

    public setWinnings(currentWin: number, totalWin?: number, tickTime: number = 0): Contract<void> {
        return new Parallel([
            () => super.setWinnings(currentWin, totalWin, tickTime),
            () => Contract.wrap(() => {
                gamevy.commonUI.updateWin({ amount: totalWin || currentWin });
            })
        ]);
    }
}
